import type { Direction } from '@/types/floor-guide';
import styles from './styles.module.scss';
import clsx from 'clsx';
import { useTickSoundInteraction } from '@/hooks';

const MAX_VISIBLE_ROWS_CLASS: Record<number, string> = {
    2: styles['navigation-direction__list--max-rows-2'],
    3: styles['navigation-direction__list--max-rows-3'],
};

type Props = {
    directions: Direction[];
    maxVisibleRows?: number;
};
export const NavigationDirection = ({ directions, maxVisibleRows }: Props) => {
    if (!Array.isArray(directions) || !directions.length) {
        return null;
    }
    const { playTick } = useTickSoundInteraction();

    return (
        <div className={styles['navigation-direction']}>
            <div
                className={clsx(
                    styles['navigation-direction__list'],
                    maxVisibleRows && MAX_VISIBLE_ROWS_CLASS[maxVisibleRows],
                    'scrollbar-custom-gray-99938f'
                )}
            >
                {Array.isArray(directions) &&
                    directions.map((direction, index) => (
                        <div
                            key={direction?.id}
                            className={styles['navigation-direction__item'] + ' focus-border '}
                            tabIndex={0}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    playTick();
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            }}
                            data-interactive
                            aria-label={direction?.description}
                            data-modal-region={index === 0}
                        >
                            <div
                                className={styles['navigation-direction__icon']}
                            >
                                {direction?.icon}
                            </div>
                            <div className={styles['navigation-direction__description']}>{direction?.description}</div>
                        </div>
                    ))}
            </div>
        </div>
    );
};
